export const GET_ANNOUNCEMENT_LIST = "GET_ANNOUNCEMENT_LIST";
export const GET_ANNOUNCEMENT_COUNT = "GET_ANNOUNCEMENT_COUNT";
export const GET_BUILDING_LIST = "GET_BUILDING_LIST";